<template>
  <div>
    <div class="field">
      <div class="columns">
        <div class="column">
          <text-field :label="firstNameLabel" v-model="firstName" :error="firstNameError" />
        </div>
        <div class="column">
          <text-field :label="lastNameLabel" v-model="lastName" :error="lastNameError" />
        </div>
      </div>
    </div>
    <div class="field">
      <text-field label="Email" v-model="email" :error="emailError" type="email" />
    </div>
    <div class="field">
      <label for="">{{attachCv}}</label>
      <upload-field :error="cvError" :widgetResumeName="cvName" :widget="true" :placeholder="attachCv" tooltip="" v-model="cv" :isFullWidth="true"></upload-field>
    </div>
    <field>
        <checkbox :value="optIn" :changeHandler="optInChangeHandler" :label="optInLabel"></checkbox>
    </field>
    <div class="field centered-captcha">
      <vue-recaptcha :sitekey="sitekey"
                     @verify="onVerify"
                     @expired="onExpired" />
    </div>
    <button v-if="jobFormLoading" class="button is-primary is-fullwidth"><spinner></spinner></button>
    <button class="button is-primary is-fullwidth is-flex space-between no-text-transform" v-else  :tooltip="actionButtonTooltip" @click="formSubmit" :disabled="!captcha">
      <img src="@/assets/tool-tip.png" class="ml-2" v-tooltip="actionButtonTooltip" />
      {{this.$t('widget.apply')}}
      <div></div>
    </button>
  </div>
</template>

<script>
import {mapState, mapMutations, mapActions} from 'vuex'
import Spinner from 'vue-simple-spinner'
import TooltipButton from '@/components/general/tooltip-button'
import Checkbox from '@/components/general/checkbox'
import Field from '@/components/general/field'
import TextField from '../general/text-field'
import UploadField from '@/components/general/upload-field'
import VueRecaptcha from 'vue-recaptcha'
import {emailRegex} from '../../constants/regex'

export default {
  name: 'WidgetJobForm',
  components: {
    TooltipButton, Checkbox, Field, TextField, UploadField, VueRecaptcha, Spinner
  },
  props: {
    actionButtonTooltip: {
      type: String
    }
  },
  data () {
    return {
      captcha: ''
    }
  },
  computed: {
    ...mapState('widget', {
      formFirstName: 'firstName',
      formLastName: 'lastName',
      formEmail: 'email',
      formCv: 'cv',
      optIn: 'optIn',
      firstNameError: 'firstNameError',
      lastNameError: 'lastNameError',
      emailError: 'emailError',
      cvError: 'cvError',
      jobFormLoading: 'jobFormLoading'
    }),
    sitekey () {
      return process.env.GOOGLE_RECAPTCHA_SITE_KEY
    },
    firstName: {
      get () { return this.formFirstName },
      set (value) { this.setFirstName(value) }
    },
    lastName: {
      get () { return this.formLastName },
      set (value) { this.setLastName(value) }
    },
    email: {
      get () { return this.formEmail },
      set (value) { this.setEmail(value) }
    },
    cv: {
      get () { return this.formCv },
      set (value) { this.setCv(value) }
    },
    cvName () {
      return this.formCv ? this.formCv.name : ''
    },
    optInLabel () {
      return this.$t('widget.optIn')
    },
    firstNameLabel () {
      return this.$t('widget.firstName')
    },
    lastNameLabel () {
      return this.$t('widget.lastName')
    },
    attachCv () {
      return this.$t('widget.attachCv')
    },
    apply () {
      return this.$t('widget.apply')
    },
    referSome () {
      return this.$t('widget.referSome')
    }
  },
  methods: {
    ...mapActions('widget', ['submitJobForm']),
    ...mapMutations('widget', ['setFirstName', 'setLastName', 'setEmail', 'setOptIn', 'setCv', 'setFirstNameError',
      'setLastNameError', 'setEmailError', 'setCvError', 'setCaptcha', 'setSelectedJobId']),
    onVerify (result) {
      this.captcha = result
      this.setCaptcha(result)
    },
    onExpired () {
      this.captcha = null
    },
    validations () {
      if (this.formFirstName.length === 0) {
        this.setFirstNameError('First Name is required')
        return false
      } else if (this.formLastName.length === 0) {
        this.setLastNameError('Last Name is required')
        return false
      } else if (this.formEmail.length === 0) {
        this.setEmailError('Email is required')
        return false
      } else if (!String(this.formEmail)
        .toLowerCase()
        .match(emailRegex)) {
        this.setEmailError('Enter valid email')
        return false
      } else if (!this.formCv) {
        this.setCvError('CV is required')
        return false
      }
      return true
    },
    formSubmit () {
      try {
        const validations = this.validations()
        if (!validations) {
          return false
        }
        this.submitJobForm()
      } catch (e) {
        console.log('error', e)
      }
    },
    optInChangeHandler (value) {
      this.optIn = value
      this.setOptIn(value)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/widget/widget-job-form.vue